import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../../context/AuthContext';
import { useState } from 'react';
import { StyledToolbar } from '../Header';
import { Box, Divider, Drawer, IconButton, Link, List, ListItem, Typography } from '@mui/material';
import { PRIVATE_PAGES, PUBLIC_PAGES } from './../../../lib/constants/routes';
import MenuIcon from '@mui/icons-material/Menu';
import { isUserLoggedIn } from '../../../context/AuthHelper';
import { get } from 'lodash';
import PrivateHeader from './PrivateHeader';
import logo from './../../../assets/images/logo/logo.svg';
import React from 'react';
function MobileHeader() {
	const { logout, authenticatedData } = useAuthentication();
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);

	const toggleDrawer = (newOpen: any) => () => {
		setOpen(newOpen);
	};

	return (
		<>
			<StyledToolbar>
				<Box>
					<IconButton onClick={toggleDrawer(true)}>
						<MenuIcon />
					</IconButton>
					<Drawer open={open} onClose={toggleDrawer(false)}>
						<List sx={{ width: '20rem' }} onClick={toggleDrawer(false)}>
							{PUBLIC_PAGES.filter((ele) => ele.display === 'true').map((ele, i) => (
								<ListItem key={i}>
									<Link onClick={() => navigate(get(ele, 'url', ''))} underline="none">
										{get(ele, 'name', '')}
									</Link>
								</ListItem>
							))}
							<Divider />
							{isUserLoggedIn() ? (
								<>
									{PRIVATE_PAGES.filter((ele) => ele.display === true).map((ele, i) => (
										<ListItem key={i}>
											<Link onClick={() => navigate(get(ele, 'url', ''))} underline="none">
												{get(ele, 'name', '')}
											</Link>
										</ListItem>
									))}
								</>
							) : (
								<ListItem>
									<Link onClick={() => navigate('login')} underline="none">
										Anmelden
									</Link>
								</ListItem>
							)}
						</List>
					</Drawer>
				</Box>

				{/* Logo */}
				<Typography variant="h6" noWrap>
					<img src={logo} alt="logo" style={{ height: '65px', position: 'sticky', top: '15%' }} />
				</Typography>
			</StyledToolbar>

			{isUserLoggedIn() && <PrivateHeader {...{ logout, authenticatedData }} />}
		</>
	);
}

export default MobileHeader;
